<script lang="ts">
export default {
    name: 'SidebarSection',
};
</script>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

// @ts-expect-error not typed yet
import { useAppSidebarStore } from '@/store/pinia/app/sidebar.js';

const props = defineProps<{
    name: string;
    route: string;
    label: string;
    icon: object;
}>();

const emit = defineEmits({
    navigate: null,
});

const sidebarStore = useAppSidebarStore();
const { collapsed } = storeToRefs(sidebarStore);

const currentRoute = useRoute();

const sectionActive = computed(() => currentRoute.matched.some(item => item.meta.section === props.name));
</script>

<template>
    <div>
        <router-link
            class="flex flex-1 rounded-md font-semibold tracking-wide uppercase hover:bg-black/30 hover:text-white focus:text-white focus:outline-hidden"
            :class="{
                'bg-black/40 text-white shadow-inner shadow-black/30': sectionActive,
                'text-gray-300': !sectionActive,
            }"
            :to="{ name: route }"
            @click="emit('navigate')"
        >
            <div
                class="flex w-full items-center space-x-4 py-2 transition-spacing duration-500"
                :class="collapsed ? 'px-2' : 'px-4'"
                :title="collapsed ? label : undefined"
            >
                <div class="relative flex h-6 w-6 shrink-0 items-center justify-center">
                    <slot name="icon">
                        <base-icon v-bind="icon" />
                    </slot>
                </div>
                <span
                    v-text="label"
                    class="overflow-hidden leading-none whitespace-nowrap"
                />
            </div>
        </router-link>
    </div>
</template>
